function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "85.099%",
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF4DC",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEDCB",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB82C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7B00",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.222%",
  y1: "50%",
  x2: "100%",
  y2: "69.277%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3E17",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "83.681%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "31.571%",
  y1: "60.23%",
  x2: "78.375%",
  y2: "42.437%",
  id: "h"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "red",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "58.156%",
  y1: "94.639%",
  x2: "100%",
  y2: "5.361%",
  id: "j"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3D15",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "73.159%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "58.156%",
  y1: "94.639%",
  x2: "100%",
  y2: "5.361%",
  id: "m"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3E17",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "73.159%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF934B",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h434v200H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.587 94.247a41.231 41.231 0 0 1-.438.006h-.113c-.36.003-.714.002-1.061 0l.256.001-.558-.002h-.499a39.063 39.063 0 0 0-1.156.02l-.269.013a12.459 12.459 0 0 0-.957.088l.129-.017c-.07.008-.138.018-.206.028l.077-.011a8.376 8.376 0 0 0-.19.028l.113-.017a7.846 7.846 0 0 0-.248.04l.136-.023c-.071.01-.141.023-.21.036l.074-.013a6.808 6.808 0 0 0-.216.042l.142-.029a6.535 6.535 0 0 0-.201.041l.06-.012a5.94 5.94 0 0 0-.232.054l.172-.042-.19.046.018-.004a5.239 5.239 0 0 0-.186.05l.169-.046a5.14 5.14 0 0 0-.214.06l.045-.013a4.683 4.683 0 0 0-.19.06l.145-.047c-.065.02-.13.04-.193.063l.048-.016c-.058.02-.115.04-.171.062l.123-.046a4.07 4.07 0 0 0-.196.075l.073-.029a3.821 3.821 0 0 0-.173.072l.1-.043c-.058.024-.116.05-.172.076l.072-.033c-.066.03-.13.06-.192.093l.12-.06a3.357 3.357 0 0 0-.166.085l.046-.025c-.056.03-.111.06-.165.093l.119-.068c-.055.03-.108.06-.16.093l.04-.025a2.949 2.949 0 0 0-.154.1l.114-.075c-.055.034-.107.07-.159.106l.045-.031a2.727 2.727 0 0 0-.334.272l.05-.047c-.04.037-.08.075-.118.114l.068-.067a2.599 2.599 0 0 0-.13.133l.062-.066a2.594 2.594 0 0 0-.121.134l.059-.068a2.602 2.602 0 0 0-.122.145l.063-.077c-.036.042-.07.086-.103.13l.04-.053c-.04.05-.077.102-.113.156l.073-.102a2.873 2.873 0 0 0-.35.63c-1.216 2.985.976 4.4 4.028 4.467l.204.003.208-.002a11.05 11.05 0 0 0 .633-.029l.216-.017a12.611 12.611 0 0 0 1.104-.147c.145-.026.29-.053.434-.084l.222-.048c.222-.05.445-.106.668-.167l.085-.024c.315-.086.86-.228 1.59-.392a44.85 44.85 0 0 1 1.416-.295c.596-.115 1.258-.23 1.974-.337l.09-.014c.527-.077 1.083-.15 1.662-.215l.36-.039c1.329-.138 2.773-.229 4.278-.232l.412.002c6.198.056 13.32 1.658 17.58 7.679l.279.408c.183.276.36.562.533.856l.253.448c.744 1.366 1.36 2.92 1.819 4.682l-.035-.125.034.125c.019.072.036.144.05.216l.011.05a4.453 4.453 0 0 1 .08.782l-.008-.226c.004.063.006.125.007.187l.001.039v.07l-.006.186a4.054 4.054 0 0 1-.215 1.097 4.063 4.063 0 0 1-.55 1.055l-.087.116-.018.024a4.255 4.255 0 0 1-.292.333l-.01.01.01-.01-.092.092-.051.049a4.173 4.173 0 0 1-.222.194l-.032.025a3.422 3.422 0 0 1-.307.225l-.06.04-.05.032a4.39 4.39 0 0 1-1.31.55l-.066.014a4.204 4.204 0 0 1-.3.057l-.05.007-.11.015-.056.005a3.62 3.62 0 0 1-.148.014h-.019a3.413 3.413 0 0 1-.128.007l-.078.002c-.098.003-.197.001-.296-.003l-.083-.005a2.98 2.98 0 0 1-.095-.007l-.067-.007a4.405 4.405 0 0 1-.684-.12 71.436 71.436 0 0 0-1.137-.28l-.367-.086a35.296 35.296 0 0 0-3.417-.63l-.325-.04a21.95 21.95 0 0 0-3.557-.126 22.856 22.856 0 0 0-1.352.105 26.192 26.192 0 0 0-1.402.191 31.994 31.994 0 0 0-2.112.418c-1.627.374-3.44.897-5.555 1.586-.297.097-.6.197-.91.301l-1.551.517a696.348 696.348 0 0 1-5.868 1.92c-.15.046-.298.094-.448.142-53.556 17.201-86.434 20.004-108.916 10.517C18.093 122.512 0 97.638 0 68.518l.01-1.133C.611 30.065 30.925 0 68.233 0h9.342c37.686 0 68.235 30.676 68.235 68.518l-.009 1.09a70.362 70.362 0 0 1-.296 5.382c.003 0 .001.006-.001.015a65.23 65.23 0 0 1-.128 1.234c.027 1.366.602 3.54 3.648 4.866.991.326 1.997.68 3.026 1.067l-.178-.066.133.05.045.016.04.015c.319.118.63.24.935.362l.122.05c.077.03.153.062.229.093a28.501 28.501 0 0 1 3.513 1.707c.667.382 1.275.768 1.823 1.154l.156.11c.106.076.208.151.308.227l.032.025c3.672 2.784 3.016 5.987-.193 7.393-.115.05-.232.098-.352.143-.119.045-.238.087-.359.127l-.051.017a10.18 10.18 0 0 1-.936.26 12.286 12.286 0 0 1-.764.15c-.13.023-.26.043-.391.06l-.018.003a15.91 15.91 0 0 1-.927.102 21.71 21.71 0 0 1-.896.055c-.234.01-.468.017-.7.021z",
  id: "e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.606 0C49.673.015 43.399 13.726 42.503 15.31c-1.948 3.443-5.722 6.5-8.604 3.074-1.322-1.572-.147-4.477.878-6.138 1.732-2.805-.573-6.318-3.83-5.88C15.016 8.502-3.22 25.278.485 46.67 2.428 57.883 15.912 71.942 38.271 61.4c14.915-7.765 16.876-22.59 19.87-39.95C59.488 13.637 63.07 10.018 66.6 8.4c3.044-1.393 3.132-5.72.064-7.06C64.526.408 62.523.004 60.654 0h-.048z",
  id: "k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.606 0C49.673.015 43.399 13.726 42.503 15.31c-1.948 3.443-5.722 6.5-8.604 3.074-1.322-1.572-.147-4.477.878-6.138 1.732-2.805-.573-6.318-3.83-5.88C15.016 8.502-3.22 25.278.485 46.67 2.428 57.883 15.912 71.942 38.271 61.4c14.915-7.765 16.876-22.59 19.87-39.95C59.488 13.637 63.07 10.018 66.6 8.4c3.044-1.393 3.132-5.72.064-7.06C64.526.408 62.523.004 60.654 0h-.048z",
  id: "n"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-9.4%",
  y: "-12.7%",
  width: "118.8%",
  height: "125.4%",
  filterUnits: "objectBoundingBox",
  id: "g"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -10,
  dy: 5,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 20,
  dy: -11,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.319463601 0 0 0 0 0.179146818 0 0 0 0.748405403 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-14.5%",
  y: "-15.4%",
  width: "129%",
  height: "130.7%",
  filterUnits: "objectBoundingBox",
  id: "l"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.0993362107 0",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-16.7%",
  y: "-17.7%",
  width: "133.4%",
  height: "135.3%",
  filterUnits: "objectBoundingBox",
  id: "o"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 11,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.638514404 0 0 0 0 0.294117647 0 0 0 1 0",
  in: "shadowInnerInner1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m161.827 217.816-79.515-.153c-44.28 0-69.064-41.886-69.568-42.726-9.482-15.811-11.589-32.15-12.642-38.475-1.054-6.324 6.32-11.068 10.008-5.797 3.687 5.27 7.375 8.96 14.222 11.068 4.875 1.5 8.712-1.732 7.902-5.27-5.795-25.299-4.662-31.093-4.686-39.33-.055-18.646 12.622-11.123 14.167-8.632 9.482 15.284 7.748 18.792 22.124 23.19 5.855 1.791 10.824-6.642 10.892-10.637.508-29.575 8.424-52.666 24.021-69.033 3.638-3.817 16.708-6.24 16.708 4.829 0 27.647 10.009 43.745 36.441 75.507 1.945 2.336 7.624 1.356 9.235-1.533.239-.429.468-.863.69-1.302 0 0 13.89-20.397 24.516 15.688a43.279 43.279 0 0 1 1.172 3.934c.798 3.246 5.413 4.817 8.895 3.03 19.945-10.231 31.003-31.115 38.56-56.196 1.216-4.038 7.93-4.865 10.643-1.322 9.512 12.42 16.001 25.697 17.56 40.375.478 4.493 7.89 5.849 10.794 1.982 8.2-10.918 14.778-26.845 21.048-47.892 4.35-14.607 12.292-26.058 22.784-34.624 3.908-3.191 10.608-.615 9.958 3.82-2.32 15.793 5.68 28.4 21.017 40.054 9.211 7 15.514 15.468 18.899 24.745 1.22 3.344 6.419 4.495 9.59 2.103 6.867-5.18 12.728-11.305 17.805-18.167 2.558-3.458 9.05-2.908 10.563.924 7.574 19.187 7.695 38.698 1.038 58.505-1.496 4.449 5.13 7.801 9.438 4.74a89.114 89.114 0 0 0 3.967-2.985c3.894-3.105 10.497-.535 9.888 3.834-5.626 40.311-36.668 65.746-101.472 65.746l-142.147-.273-24.515.273zM63.003 60.654c.39 2.262 1.036 4.524 1.683 6.704l.176.592.175.588c1.917 6.442 3.432 12.003-2.297 14.436-2.73 1.16-6.817-.756-8.854-4.182-.886-3.476-3.129-14.756 3.127-21.334 2.987-3.142 5.569.758 5.99 3.196zm328.332-22.69c2.075-3.59 7.516-2.442 8.024 1.674 2.24 18.173-1.339 31.527-11.52 39.415-4.325 3.35-9.619 1.763-11.489-3.382-5.472-15.051 6.933-23.774 14.985-37.707zM286.537.766c6.963 9.55 9.463 17.05 9.883 25.38 1.3 25.747-27.42 28.17-29.42 4.007-.2-2.417.443-4.847.995-6.902.525-1.95 3.746-2.378 5.06-.685l.076.097c1.449 1.84 5.04 1.887 5.869.153 3.243-6.786 2-9 1.5-16s4.802-7.745 6.037-6.05z",
  fill: "url(#c)",
  transform: "translate(4 15.184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m190.371 215.669 148.91.458h.161c11.14-.245 37.127-26.378 44.48-53.03 1.658-6.012-5.863-10.838-11.75-7.442-.869.502-1.748.973-2.639 1.414-5.343 2.65-11.908-1.033-11.528-6.412 1.405-19.881-3.56-35.128-15.414-45.378-4.9-4.237-13.264-1.065-13.176 4.974.21 14.399-4.452 26.752-14.522 36.825-3.407 3.407-9.537 3.049-12.401-.724a55.131 55.131 0 0 1-4.243-6.491c-2.74-4.913-10.524-5.212-13.725-.52-7.665 11.232-16.597 19.888-27.071 25.404-2.848 1.5-6.505 1.184-9.002-.738-4.949-3.81-7.895-8.6-8.707-14.44-.733-5.273-7.583-7.903-12.394-4.683-3.94 2.638-7.172 5.673-9.616 9.149-2.718 3.866-8.626 6.329-12.08 2.947-.817-.799-2.381-3.507-2.766-4.294-3.056-6.251-8.29-7.183-10.542-3.042-3.865 7.11-4.7 9.61-10.56 15.776-3.432 3.611-6.994 2.435-9.816-1.563-7.35-10.41-8.59-17.684-16.458-22.775-8.96-5.797-12.71-7.252-17.92-15.811-7.378-12.122-17.43-48.982-24.771-7.379-7.342 41.603-10.014 19.501-15.284 21.082-5.271 1.581 1.133 19.228-8.96 17.393-5.798-1.054-12.773-10.603-15.765-15.486-7.953-12.975-15.305 4.824-10.588 24.446 8.196 34.09 21.61 40.583 35.84 47.961 25.825 1.581 29.146-1.032 43.218 1.054 27.628 4.097 29.203 1.283 49.09 1.325z",
  fill: "url(#d)",
  opacity: 0.5,
  transform: "matrix(-1 0 0 1 448.896 15.184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.614 203.193c-2.314 0-4.19-2.202-4.19-4.918v-19.163c0-2.717 1.876-4.919 4.19-4.919 2.313 0 4.19 2.202 4.19 4.92v19.162c0 2.716-1.877 4.918-4.19 4.918",
  fill: "#1D1D1B"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(140 49.562)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#f)",
  xlinkHref: "#e"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#g)",
  xlinkHref: "#e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.896-4.438c-12.055.008-18.973 7.587-19.961 8.463-2.148 1.903-6.31 3.593-9.488 1.7-1.457-.87-.162-2.475.969-3.394 1.909-1.55-.632-3.492-4.223-3.25C47.625.262 27.516 9.536 31.603 21.36c2.142 6.198 17.01 13.97 41.665 8.143 16.447-4.292 17.841-13.7 23.759-21.068 1.485-4.319 8.616-1.303 12.508-2.197 3.356-.771-1.577-9.196-4.96-9.936a31.09 31.09 0 0 0-6.625-.741h-.054z",
  fill: "url(#h)",
  opacity: 0.354,
  mask: "url(#i)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(165.145 17)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#j)",
  xlinkHref: "#k"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#l)",
  xlinkHref: "#k"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(165.145 17)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#m)",
  xlinkHref: "#n"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#o)",
  xlinkHref: "#n"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M175.804 101.308a3.376 3.376 0 0 1-3.37 3.384 3.377 3.377 0 0 1-3.37-3.384 3.377 3.377 0 0 1 3.37-3.383 3.376 3.376 0 0 1 3.37 3.383M199.713 101.308a3.376 3.376 0 0 1-3.37 3.384 3.377 3.377 0 0 1-3.37-3.384 3.377 3.377 0 0 1 3.37-3.383 3.376 3.376 0 0 1 3.37 3.383",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.44 107.664c-5.526 0-10.006 4.499-10.006 10.048h20.012c0-5.55-4.48-10.048-10.006-10.048",
  fill: "#FFDA00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.634 124.552c3.762 0 6.813-3.062 6.813-6.84H178.82c0 3.778 3.05 6.84 6.813 6.84",
  fill: "#F2A100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.133 203.193c-2.314 0-4.19-2.202-4.19-4.918v-19.163c0-2.717 1.876-4.919 4.19-4.919 2.314 0 4.19 2.202 4.19 4.92v19.162c0 2.716-1.876 4.918-4.19 4.918",
  fill: "#1D1D1B"
}))));

function SvgImgHomeTopFinix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 200,
    viewBox: "0 0 434 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHomeTopFinix);
export default __webpack_public_path__ + "static/media/img_home_top_finix.da7bb587.svg";
export { ForwardRef as ReactComponent };